<template>
    <div>
        <v-system-bar v-if="show && isStaging" app color="#e65100" class="staging-banner">
            <v-spacer />
            <v-icon x-small color="white" class="mr-1">mdi-flask-outline</v-icon>
            <span>Ambiente de Homologação</span>
            <span class="staging-banner__separator">|</span>
            <span>Os dados aqui não afetam o sistema em produção</span>
            <v-spacer />
        </v-system-bar>
        <v-app-bar app clipped-left flat color="grey lighten-4" v-if="show">
            <v-app-bar-nav-icon v-if="menu.length > 0" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>
                <a href="#" @click.prevent="goToHome" style="cursor: pointer;">
                    <v-img src="/img/sysclass_logo.png" max-width="150" alt="Logo SysClass" />
                </a>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            
            <!-- Seletor de Período Compacto -->
            <div v-show="showChangeWorkTime && menu.length > 0" class="d-flex align-center mr-2">
                <v-chip
                    outlined
                    color="primary"
                    class="mr-2 font-weight-medium"
                    small
                >
                    <v-icon left small>mdi-calendar</v-icon>
                    {{ acesso.periodo ? acesso.periodo.name : 'Selecionar' }}
                </v-chip>
                
                <v-menu
                    v-model="menuWorkTime"
                    :close-on-content-click="false"
                    offset-y
                    left
                    max-width="300"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small
                            outlined
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :loading="loadingWorkTime"
                            class="text-none"
                        >
                            <v-icon left small>mdi-swap-horizontal</v-icon>
                            <span class="hidden-sm-and-down">Trocar Período</span>
                        </v-btn>
                    </template>
                    
                    <v-card>
                        <v-card-title class="text-subtitle-2 pb-2">
                            Selecionar Período
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <SysSelectWorkTime
                                ref="selectWorkTime"
                                :loading="loadingWorkTime"
                                label="Período"
                                filter-active
                                v-bind:model.sync="selectedWorkTime"
                                dense
                                outlined
                                return-object
                            />
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text small @click="menuWorkTime = false">Cancelar</v-btn>
                            <v-btn 
                                color="primary" 
                                small 
                                :disabled="!selectedWorkTime || (acesso.periodo && selectedWorkTime.id === acesso.periodo.id)"
                                :loading="loadingWorkTime"
                                @click="confirmChangeWorkTime"
                            >
                                Confirmar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>
                
            <!-- Alternância de Tema (Acessibilidade) -->
            <EmcAccessibilityThemeToggle v-if="user.id" />

            <!-- Notificações -->
            <SysNotificationNotificationBell v-if="user.id" />

            <!-- Botão Logout direto no header (para painel do professor) -->
            <v-tooltip bottom v-if="isTeacherPanelRoute">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        icon
                        v-bind="attrs" 
                        v-on="on" 
                        @click="sair()"
                        :loading="exit"
                        class="mr-1"
                    >
                        <v-icon>mdi-logout</v-icon>
                    </v-btn>
                </template>
                <span>Sair</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        style="cursor: help;" 
                        small 
                        v-bind="attrs" 
                        v-on="on" 
                        v-if="user.id && user.mode == 'user'"  
                        to="/faq-questions" 
                        icon
                        aria-label="Ajuda e Perguntas Frequentes"
                    >
                        <v-icon small color="indigo" aria-hidden="true">mdi-help-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span> Ajuda </span>
            </v-tooltip>
            

            <v-menu v-if="user && user.id && $route.name != 'availability-teacher'" :close-on-content-click="false" :nudge-width="100" offset-y :open-on-hover="!isTeacherPanelRoute">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-1">
                        <EmcBaseAvatar 
                            :size="36"
                            :src="user.url_avatar"
                            :text="user.initials"
                            v-if="user.id"
                            class="avatar-clickthrough"
                        />
                    </v-btn>
                </template>

                <v-card :max-width="400">
                    <v-list>
                        <v-list-item>
                            <v-list-item-avatar>
                                
                                    <EmcBaseAvatar 
                                        :size="36"
                                        :src="user.url_avatar"
                                        :text="user.initials"
                                        v-if="user.id"
                                    />
                                
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>{{ user.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>
                        
                        <!-- Meus Dados - usuário comum -->
                        <v-list-item v-if="(acesso.instituicao && acesso.instituicao.id) && !isTeacherPanelRoute" to="/profile" @click="showMenu = !showMenu">
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Meus Dados</v-list-item-title>
                        </v-list-item>

                        <!-- Meus Dados - professor (abre modal de perfil) -->
                        <v-list-item v-if="isTeacherPanelRoute" @click="openTeacherProfile">
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Meus Dados</v-list-item-title>
                        </v-list-item>

                        <!-- Meus chamados - apenas usuário comum com is_master -->
                        <v-list-item v-if="(acesso.instituicao && acesso.instituicao.id && user.is_master) && !isTeacherPanelRoute" to="/my-tickets" @click="showMenu = !showMenu">
                            <v-list-item-icon>
                                <v-icon>mdi-text-box</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Meus chamados</v-list-item-title>
                        </v-list-item>

                        <v-list-item @click.stop.prevent="sair()">
                            <v-list-item-icon>
                                <v-icon>{{ exit ? 'mdi-spin mdi-loading' : 'exit_to_app'}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Sair</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

        </v-app-bar>

        <v-navigation-drawer app clipped left v-model="drawer" temporary>
            <div class="pa-3">
                <FormsTextField
                    v-model="searchQuery"
                    placeholder="Pesquisar menu..."
                    append-icon="mdi-magnify"
                    outlined
                    dense
                    hide-details
                    class="full-width-search" />
            </div>
            <v-list nav dense>
                <template v-for="item in filteredMenusSysclass">
                    <v-list-group  v-if="Object.keys(item.children).length > 0"  :key="item.id"  v-model="item.model"  :prepend-icon="item.icon">
                
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.to">

                            <v-list-item-action v-if="child.icon" >
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                
                            <v-list-item-content>
                                <v-list-item-title >{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </v-list-group>

                    <v-list-item v-else :key="item.id" link :to="item.to">
              
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
              
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <v-divider class="my-2" v-if="filteredMenusInternal.length > 0" />

                <template v-for="item in filteredMenusInternal">
                    <v-list-group  v-if="Object.keys(item.children).length > 0"  :key="item.id"  v-model="item.model"  :prepend-icon="item.icon">
                
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.to">

                            <v-list-item-action v-if="child.icon" >
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                
                            <v-list-item-content>
                                <v-list-item-title >{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </v-list-group>

                    <v-list-item v-else :key="item.id" link :to="item.to">
              
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
              
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>

            </v-list>
        </v-navigation-drawer>

    </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import debounce from 'lodash/debounce';
import { eventBus } from '../../js/eventBus'


export default {
    name: "SysCoreNavigationBar",
    data: () => ({
        drawer: false,
        group: null,
        showMenu: false,
        exit: false,
        env_sysclass: process.env.VUE_APP_ENV,
        model: null,
        showChangeWorkTime: true,
        loadingWorkTime: false,
        searchQuery: '',
        menuWorkTime: false,
        selectedWorkTime: null,
    }),
    computed: {
        ...mapState('auth', ['acesso', 'user', 'menu']),
        show() {
            return this.$route.name !== 'login' && this.$route.name !== 'access-teacher' && this.$route.name !== 'login/teacher';
        },

        isStaging(){
            return !this.env_sysclass || !this.env_sysclass.toString().includes('production');
        },
        isTeacherPanelRoute() {
            return this.$route.name === 'teacher/page' || this.$route.name === 'teacher-panel'
        },
        filteredMenusSysclass() {
            // Garantir que menu seja sempre um array
            if (!Array.isArray(this.menu)) {
                return [];
            }

            const normalizeString = (str) =>
                    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

            const query = normalizeString(this.searchQuery);

            const filterMenus = (menus) => {
                return menus
                .map(menu => {

                    const nameNormalized = normalizeString(menu.text || menu.name || '');
                    const hasMatch = nameNormalized.includes(query);

                    const filteredChildren = menu.children
                    ? filterMenus(menu.children)
                    : [];

                    if (hasMatch || filteredChildren.length) {
                    return {
                        ...menu,
                        children: filteredChildren
                    };
                    }
                    return null;
                })
                .filter(Boolean);
            };

            let itemsMenu = this.menu.filter((menu) => { return menu.is_internal == 0 });
            return this.searchQuery ? filterMenus(itemsMenu) : itemsMenu;
        },
        filteredMenusInternal() {
            // Garantir que menu seja sempre um array
            if (!Array.isArray(this.menu)) {
                return [];
            }

            const normalizeString = (str) =>
                    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

            const query = normalizeString(this.searchQuery);

            const filterMenus = (menus) => {
                return menus
                .map(menu => {

                    const nameNormalized = normalizeString(menu.text || menu.name || '');
                    const hasMatch = nameNormalized.includes(query);

                    const filteredChildren = menu.children
                    ? filterMenus(menu.children)
                    : [];

                    if (hasMatch || filteredChildren.length) {
                    return {
                        ...menu,
                        children: filteredChildren
                    };
                    }
                    return null;
                })
                .filter(Boolean);
            };

            let itemsMenu = this.menu.filter((menu) => { return menu.is_internal == 1 });
            return this.searchQuery ? filterMenus(itemsMenu) : itemsMenu;
        }
    },
    watch: {
        
        $route (to, from){
            
            if(to.query.refreshWorkTime && this.$refs.selectWorkTime){
                this.$refs.selectWorkTime.getItems();
            }
            
            this.showChangeWorkTime = (to.path != '/worktime');
        },

        drawer (val) {
            if(!val){
                this.searchQuery = '';
            }
        },

        searchQuery(newVal) {
            if (newVal && newVal.length >= 2) {
                this.debouncedTrackSearch(newVal);
            }
        },

        menuWorkTime(val) {
            if (val && this.acesso && this.acesso.periodo) {
                this.selectedWorkTime = this.acesso.periodo;
            }
        },

        'acesso.periodo': {
            handler(val) {
                if (val) {
                    this.selectedWorkTime = val;
                }
            },
            immediate: true
        }

    },
    methods: {
      ...mapActions('auth', ['ActionSignOut', 'ActionSetAcesso', 'ActionSetSession', 'ActionSetToken', 'ActionSetTeacherPeriod']),
      goToHome() {
        const isTeacherMode = this.user?.mode === 'teacher'

        if (isTeacherMode) {
            const periodId = this.$route.query.period_id || this.acesso?.periodo?.id
            this.$router.replace({
                name: 'teacher-panel',
                query: periodId ? { period_id: periodId } : {}
            }).catch(() => {})
            return
        }

        this.$router.replace('/').catch(() => {})
      },
      openTeacherProfile() {
        eventBus.$emit('teacher-panel-open-profile')
      },
      trackSearchTerm(term) {
        window.gtag('event', 'menu_search', {
            search_term: term,
            event_category: 'Menu',
            event_label: 'Busca no menu'
        });
      },
      confirmChangeWorkTime() {
        if (this.selectedWorkTime) {
          this.changeWorkTime(this.selectedWorkTime);
        }
      },

      async changeWorkTime(periodo) {

        const newAccess = { ...this.acesso, periodo };
        this.loadingWorkTime = true;
        this.menuWorkTime = false;

        await this.ActionSetAcesso(newAccess);

        const isTeacherPanel = this.$route.name === 'teacher/page' || this.$route.name === 'teacher-panel'

        try {
            if (isTeacherPanel) {
                await this.ActionSetTeacherPeriod({ work_time_id: periodo.id })
                eventBus.$emit('teacher-panel-period-change', periodo)
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        period_id: periodo.id
                    }
                }).catch(() => {})
                return
            }

            const sessionPayload = {
                educational_group_id:   newAccess.grupo.id,
                institution_id:         newAccess.instituicao.id,
                campuses:               newAccess.campus.map(o => ({ id: o['id'], name: o['name'], initials: o['initials'], abbreviation: o['abbreviation'], institution_id: o['institution_id'], brand_id: o['brand_id'] })),
                work_time_id:           periodo.id,
            }

            const r = await this.ActionSetSession(sessionPayload)
            await this.ActionSetToken(r.data.token)
            window.location.reload()
        } finally {
            this.loadingWorkTime = false
        }

      },
      sair(){
        this.exit = true;
        this.ActionSignOut()
            .then(() => { this.exit = false; })
      }
    },
    created() {
        this.debouncedTrackSearch = debounce(this.trackSearchTerm, 500);
    }
}
</script>

<style scoped>
.full-width-search {
    width: 100%;
}

.avatar-clickthrough {
    pointer-events: none;
}

.staging-banner {
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.staging-banner__separator {
    margin: 0 8px;
    opacity: 0.5;
}
</style>